export default {
  GET: 'get',
  CREATE: 'create',
};
